import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // StrictMode removed to prevent duplicate function calls in development
  // In production, this doesn't affect behavior but prevents unnecessary duplicate Firebase calls
  <App />
);
